{
  "CONTACTS_FILTER": {
    "TITLE": "Contacten filteren",
    "SUBTITLE": "Voeg hieronder filters toe en druk op 'Verzenden' om contacten te filteren.",
    "EDIT_CUSTOM_SEGMENT": "Bewerk Segment",
    "CUSTOM_VIEWS_SUBTITLE": "Filters toevoegen of verwijderen en bijwerken van uw segment.",
    "ADD_NEW_FILTER": "Filter toevoegen",
    "CLEAR_ALL_FILTERS": "Alle filters wissen",
    "FILTER_DELETE_ERROR": "U moet minstens één filter hebben om op te slaan",
    "SUBMIT_BUTTON_LABEL": "Bevestigen",
    "UPDATE_BUTTON_LABEL": "Segment Updaten",
    "CANCEL_BUTTON_LABEL": "Annuleren",
    "CLEAR_BUTTON_LABEL": "Filters wissen",
    "EMPTY_VALUE_ERROR": "Waarde is vereist",
    "SEGMENT_LABEL": "Segment Naam",
    "SEGMENT_QUERY_LABEL": "Segment Query",
    "TOOLTIP_LABEL": "Contacten filteren",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "EN",
      "OR": "OF"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Gelijk aan",
      "not_equal_to": "Niet gelijk aan",
      "contains": "Bevat",
      "does_not_contain": "Bevat niet",
      "is_present": "Is aanwezig",
      "is_not_present": "Is niet aanwezig",
      "is_greater_than": "Is groter dan",
      "is_lesser_than": "Is minder dan",
      "days_before": "Is x dagen vóór"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Waarde is vereist"
    },
    "ATTRIBUTES": {
      "NAME": "Naam",
      "EMAIL": "E-mailadres",
      "PHONE_NUMBER": "Telefoon nummer",
      "IDENTIFIER": "Identifier",
      "CITY": "Woonplaats",
      "COUNTRY": "Land",
      "CUSTOM_ATTRIBUTE_LIST": "Lijst",
      "CUSTOM_ATTRIBUTE_TEXT": "Tekst",
      "CUSTOM_ATTRIBUTE_NUMBER": "Getal",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Selectievakje",
      "CREATED_AT": "Aangemaakt op",
      "LAST_ACTIVITY": "Laatste Activiteit",
      "REFERER_LINK": "Verwijzer link",
      "BLOCKED": "Blocked",
      "LABELS": "Labelen"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standaard Filters",
      "ADDITIONAL_FILTERS": "Aanvullende filters",
      "CUSTOM_ATTRIBUTES": "Aanpasbare attributen"
    }
  }
}
